.component {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 8px 20px;
  background-color: var(--ice-blue-dark);
  border-bottom: solid 1px var(--pinkish-grey);
}

.infoIcon {
  width: 18px;
  height: 18px;
}

.text {
  flex: 1;
  color: var(--marine);
  font-size: 13px;
}

.cta {
  background-color: var(--tealish);
  color: var(--fully-white);
  border-radius: 14px;
  padding: 4px 16px;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
}

.cta:hover {
  opacity: 0.8;
}

.xIcon {
  width: 11px;
  height: 11px;
  padding: 6px;
  object-fit: contain;
  cursor: pointer;
  border-radius: 50%;
}

.xIcon:hover {
  background-color: var(--light-grey);
}
